module.exports = __webpack_public_path__ + "static/media/close.ed893040.svg";